<template>
  <div class="container">
    <div class="card" id="empty-form">
      <p>¡Inicia tu plantilla!</p>

      <a-button
        type="link"
        class="button"
        @click="emit('openDrawer')"
        id="open-template-items-drawer"
      >
        <PlusOutlined />
        Agrega un elemento para iniciar con tu plantilla
      </a-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PlusOutlined } from "@ant-design/icons-vue";

const emit = defineEmits<{
  openDrawer: [];
}>();
</script>

<style scoped lang="sass">
.container
  background-color: white
  margin-left: 30px

.card
  flex: 1 1 auto
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  margin: 24px 36px
  border: 1px dotted $blue-5
  border-radius: 4px
  padding: 30px 0

p
  color: $gray-8
</style>
